export default __webpack_public_path__ + "static/media/trusted-by-sony.18fd5f36.png";